import React, { useState } from 'react';
import { generateStartupIdea } from './lib/generateIdea';
import tankEmpty from './assets/tank-face-empty.png';
import tankFull from './assets/tank-face-full.png';

export default function HopiumTank() {
  const [idea, setIdea] = useState('');
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [progress, setProgress] = useState(0);
  const [modalIdea, setModalIdea] = useState(null);
  const [isSchizo, setIsSchizo] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const newIdea = await generateStartupIdea();
      setIdea(newIdea);
      setIdeas((prev) => [newIdea, ...prev]);
      setProgress((prev) => {
        const next = Math.min(prev + 10, 100);
        if (next >= 100) {
          window.location.href = 'https://s3labs.io';
        }
        return next;
      });
      setIsSchizo(true);
      setTimeout(() => setIsSchizo(false), 800);
    } catch (err) {
      console.error('Error generating idea', err);
    } finally {
      setLoading(false);
      setClicked(true);
    }
  };

  const tweetAndClose = (idea) => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        `new idea: ${idea}\n\ngenerate ideas now at hopiumlabs.fun\n\ncc @royalarp`
      )}`,
      '_blank'
    );
    setModalIdea(null);
  };

  return (
    <div className={`relative min-h-screen bg-black text-white transition-all duration-300 ${isSchizo ? 'blur-sm saturate-200 hue-rotate-90 animate-shake' : ''}`}>
      {/* Fixed Tank Section */}
      <div className="pt-2 flex flex-col items-center">
        
          <div className="pt-10 mb-4" style={{ width: '160px' }}>
            <div className="bg-pink-700 h-2 w-full rounded-md overflow-hidden">
              <div
                className="bg-pink-400 h-2 transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        
        <img
          src={clicked || progress >= 100 ? tankFull : tankEmpty}
          alt="Hopium Tank"
          onClick={handleClick}
          className="w-24 h-24 cursor-pointer mb-4"
        />
        <p className="italic text-sm text-pink-200 text-center">
          click the tank to inhale
          <br />
          hopium
        </p>
        {idea && (
          <>
            <p className="text-center italic mt-4 max-w-xl md:max-w-2xl px-4">"{idea}"</p>
            <a
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                `new idea: ${idea}\n\ngenerate ideas now at hopiumlabs.fun\n\ncc @royalarp`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 mb-10 inline-block bg-pink-600 hover:bg-pink-500 text-white font-bold py-2 px-4 rounded"
            >
              tweet this idea
            </a>
          </>
        )}
      </div>

      {/* Scrollable Idea History */}
      <div className="w-full max-w-md mx-auto px-4 pt-10 pb-16">
        {ideas.length > 0 && (
          <>
            <h2 className="text-pink-400 text-xl font-bold mb-2 text-center">
              your hopium fueled ideas ({ideas.length})
            </h2>
            <ul className="list-disc list-inside space-y-2">
              {ideas.map((idea, index) => (
                <li
                  key={index}
                  className="cursor-pointer hover:text-pink-300 text-sm italic"
                  onClick={() => setModalIdea(idea)}
                >
                  {idea}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>

      {/* Modal */}
      {modalIdea && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-zinc-900 p-6 rounded-lg max-w-sm w-full text-center">
            <p className="text-white italic mb-4">"{modalIdea}"</p>
            <button
              onClick={() => tweetAndClose(modalIdea)}
              className="inline-block bg-pink-600 hover:bg-pink-500 text-white font-bold py-2 px-4 rounded"
            >
              Tweet this idea
            </button>
            <button
              onClick={() => setModalIdea(null)}
              className="block mt-4 text-sm text-pink-300 hover:text-pink-400"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
